export default __webpack_public_path__ + "static/assets/no_pills.4daaa997.png";